import { IClientConfig } from '@front/interfaces/client-config.interface';
import { ekiConfig } from './eki.config';

export const ekiWorkerConfig: IClientConfig = {
  ...ekiConfig,
  pooledModeling: true
};
